import React from 'react';
import { NumberInput, TextInput } from 'ui-toolkit';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IHasMetaDataModalProps from './IHasMetaDataModalProps';
import IHasMetaDataModalState from './IHasMetaDataModalState';
import IItemProps from './IItemProps';
import ItemMetaDataModal, { IItemMetaDataModalRef } from './ItemMetaDataModal/ItemMetaDataModal';
import SharedItemCells from './SharedItemCells';
import { IPrepaymentOtherViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { isNil } from 'lodash';

interface IPrepaymentOtherProps
  extends IItemProps,
    IHasItemDataProps<IPrepaymentOtherViewItem>,
    Required<IHasItemEventProps<IPrepaymentOtherViewItem>>,
    IHasMetaDataModalProps {}

type IPrepaymentOtherState = IHasMetaDataModalState;

export default class PrepaymentOther extends React.Component<IPrepaymentOtherProps, IPrepaymentOtherState> {
  public state = { expanded: !this.props.disableAutoExpand && this.props.data.new };
  private modal = React.createRef<IItemMetaDataModalRef>();
  private firstInput: HTMLInputElement | null = null;

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;
    const generateDefaultOnChangeHandler = createOnChangeHandlerGenerator(data, onChange);
    const monthsOnChange = generateDefaultOnChangeHandler('months');
    const labelOnChange = generateDefaultOnChangeHandler('label');
    const payeeOnChange = generateDefaultOnChangeHandler('payee');
    return (
      <SharedItemCells {...this.props} readOnly={!hasEditPermissions}>
        <ItemMetaDataModal
          label={
            <span>
              {data.label} (<strong>{`${isNil(data.months) ? '__' : data.months} mon`}</strong>
              )&nbsp;to&nbsp;{data.payee}
            </span>
          }
          expanded={this.state.expanded}
          expandedLabel={
            <TextInput
              onChange={labelOnChange}
              getInputRef={this.setFirstInput}
              value={data.label}
              readOnly={!hasEditPermissions}
            />
          }
          onToggle={this.onModalToggleEvent}
          ref={this.modal}
        >
          <div className="non-interest-prepayment__extra">
            <div className="non-interest-prepayment__months">
              <NumberInput
                label="No. of months"
                name="months"
                allowNegative={false}
                onBlur={this.onBlurEvent}
                onChange={monthsOnChange}
                value={data.months}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />
            </div>
            <div className="non-interest-prepayment__payee">
              <TextInput
                label="Payee"
                placeholder="Payee"
                onChange={payeeOnChange}
                onBlur={this.onBlurEvent}
                value={data.payee}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />
            </div>
          </div>
        </ItemMetaDataModal>
      </SharedItemCells>
    );
  }

  private setFirstInput = (element: HTMLInputElement) => {
    this.firstInput = element;
  };

  private onBlurEvent = (event: React.FocusEvent) => {
    const node = this.modal.current;
    if (node && event.relatedTarget && !node.modalContains(event.relatedTarget as HTMLElement)) {
      this.setState({
        expanded: false,
      });
    }
  };

  private onModalToggleEvent = (expanded: boolean) => {
    this.setState({ expanded });
    if (this.firstInput) {
      this.firstInput.focus();
    }
  };
}
